export const textConstants = {
    controlPanelExplanation: 'Тут много текста. Рассказывается о том, как пользоваться этой панелью свойств и фильтров.',
    motivationHeaderText: 'Анализируйте прифили людей в VK, Instagram, Twitter, Facebook. Узнайте много нового о ваших друзьях и знакомых. Сравнивайте аккаунты между собой. Найдите нужную информацию о каждом!',
    messageWrongSyntax: 'В тексте запроса допущена синтаксическая ошибка'
}
